module.exports = __webpack_public_path__ + "static/media/img3-1.240a078b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/biosense/biomasa/img3-1.png
// module id = 1268
// module chunks = 3